import { RefObject, useEffect } from 'react';

export const useFocusAtEnd = (ref: RefObject<HTMLTextAreaElement>) => {
  useEffect(() => {
    const input = ref.current;
    if (!input) return;
    input.focus({ preventScroll: true });
    input.setSelectionRange(input.value.length, input.value.length);
  }, [ref]);
};
